var _linearGradient, _path, _linearGradient2, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 358.3 432.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 49.218,
    x2: 255.106,
    y1: 345.617,
    y2: 198.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ff1932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#771620"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M206.7 153.3s42.7 28 53.2 34.8c10.5 6.8 33.5 23.8 33.5 45.9s-18.9 35.5-28.7 42S96.9 390.6 85.8 397.6c-11.1 7-14.5 8.3-21.7 8.3s-23.8-3.6-23.8-26.4v-85.4c0-15.3.7-27.5 26.7-45.8s139.7-95 139.7-95z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 104.525,
    x2: 208.721,
    y1: 251.219,
    y2: 127.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff1932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#771620"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M64.9 42.3s220.2 150.1 229.4 156.8c9.2 6.7 23.7 20.1 23.7 37.5 0 19.5-11.6 32.3-23.7 40.8 0 0-72.1 48.9-76.4 51.9-4.2 3-6.7 4.8-10.6 4.8s-11.6-1.9-11.6-15-7.1-24.5-18.9-34.8-68.6-48.5-84-59.8C77.5 213.1 65 203.6 65 180s-.1-137.7-.1-137.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 9.736,
    x2: 83.941,
    y1: 150.696,
    y2: 62.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff1932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#771620"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M53.1 36.4v150.5s-12.9-7.4-12.9-30.4v-130l12.9 9.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c7d34d222d9de25ae91f411e9c369a75.svg";
export { ForwardRef as ReactComponent };